import(/* webpackMode: "eager", webpackExports: ["RegisterClientPage"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/[hostname]/(auth)/register/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandHeader"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/libs/ui/brand-header/brand-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegisterPageHeading"] */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/libs/ui/register-page-heading/register-page-heading.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
